import React, { useState, useEffect } from "react"

import { OutboundLink } from "gatsby-plugin-gtag"
import { withSession } from "~contexts/SessionContext"

import * as style from "./ConsoleButton.module.scss"

const ConsoleButton = ({ microcopy, session }) => {
  // determine the 2 links to switch between
  const LoginLink = {
    href: "https://account.box.com/login?redirect_url=%2Fdevelopers%2Fconsole",
    text: microcopy.text("explorer.buttons.login"),
  }

  const MyAppsLink = {
    href: "https://account.box.com/developers/console",
    text: microcopy.text("headers.primary.buttons.console.text"),
  }

  const [link, setLink] = useState(LoginLink)
  const updateLink = () => {
    session?.hasAccount && setLink(MyAppsLink)
  }
  useEffect(updateLink, [session])

  return (
    <div className={style.consoleButton}>
      <OutboundLink
        href={link.href}
        title={link.text}
        target="_blank"
        rel="noopener noreferrer"
        className={style.link}
      >
        <span>{link.text}</span>
      </OutboundLink>
    </div>
  )
}

export default withSession(ConsoleButton)
